export class ItemDetailDto {
    productId = 0;
    classCode = '';
    quantity = 0;
    extendedPrice = 0;
  }
  